import { ChangeEvent, KeyboardEvent, ReactNode } from 'react';

interface PromptFieldProps {
    heading: string;
    description: ReactNode;
    value: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
    formSubmitted: boolean;
    disabled: boolean;
    baseTextareaClass: string;
    counterClassName: string;
}

export const PromptField = ({
    heading,
    description,
    value,
    onChange,
    onKeyDown,
    formSubmitted,
    disabled,
    baseTextareaClass,
    counterClassName
}: PromptFieldProps) => (
    <>
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-jtc-very-dark-grey'}`}>
            {heading}
        </h4>
        <p className={`text-sm mb-4 break-words ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            {description}
        </p>
        <textarea
            id="promptMessage"
            className={`${baseTextareaClass} ${formSubmitted && !value
                ? 'border-jtc-pink focus:border-jtc-pink'
                : 'border-jtc-grey focus:border-jtc-blue focus:ring-1 focus:ring-jtc-blue focus:outline-none'
                }`}
            placeholder={formSubmitted && !value ? 'A prompt message is required...' : 'Enter prompt message here...'}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
        />
        <div className={counterClassName}>
            {value.length} / 10000
        </div>
    </>
);
